import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorTinder = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#ColorTinder_svg__a)">
      <path
        fill="url(#ColorTinder_svg__b)"
        fillRule="evenodd"
        d="M8.17 9.885a.06.06 0 0 1-.067-.019c-.743-.983-.93-2.674-.975-3.324-.009-.125-.15-.195-.262-.132-2.294 1.288-4.423 4.336-4.423 7.279 0 5.056 3.512 9.297 9.557 9.297 5.664 0 9.557-4.371 9.557-9.296 0-6.445-4.606-10.727-8.708-12.662a.147.147 0 0 0-.209.153c.528 3.473-.201 7.25-4.47 8.704Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <radialGradient
        id="ColorTinder_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(20.4193 0 0 23.4741 12 22.99)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7854" />
        <stop offset={1} stopColor="#FD267D" />
      </radialGradient>
      <clipPath id="ColorTinder_svg__a">
        <path fill="#fff" d="M0 0h19.116v22H0z" transform="translate(2.441 1)" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColorTinder)
export default ForwardRef
